<template>
	<v-app>
		<router-view name="main"></router-view>
	</v-app>
</template>

<script>
export default {
	name: "App",
	data: () => ({})
};
</script>
